export const sourceKey = {
    user: "user",
    home: "home",
    product: "product",
};
